export default __webpack_public_path__ + "static/media/fakestagram.07f73642.png";